import biggpayLogo from "./assets/dilliPay.png";
import biggpayLogo_sm from "./assets/dilliPay.png";
import airIndia from "./assets_travel/images/icons/AI.png";
import closeicon from "./assets_travel/images/icons/close1.png";
import successVdo from "./assets/video/checkmark.mp4";
import failedVdo from "./assets/video/exclaimation.mp4";
import smallLogo from "./assets/small_logo.jpeg";
import outlet_reg_img from "./assets/outletreg.png";
import LoginPageIllustrator from "./assets/LoginPageSideIllustration.svg";
import ITR from "./assets/itrimage.png";
//
import bbps from "./assets/bbps.png";
import login_illustration from "./assets/loginIllustration.png";
import landingPageIllustration from "./assets/landing-page-assets/landingPageillustration2.png";
import landingPageIllustration1 from "./assets/landing-page-assets/landingPageillustration3.png";
import contact from "./assets/sidebar_icons/contactUs.png";
import dash from "./assets/sidebar_icons/dashboard.svg";
import express from "./assets/sidebar_icons/ExpressTransfer.png";
import money from "./assets/sidebar_icons/moneyTransfer.png";
import rechargeicon from "./assets/sidebar_icons/recharge.png";
import txn from "./assets/sidebar_icons/transaction.png";
import upiTrans from "./assets/sidebar_icons/upiTransfer.png";
import hotel from "./assets/sidebar_icons/hotelbooking.svg";
import bus from "./assets/sidebar_icons/busbooking.svg";
import flight from "./assets/sidebar_icons/flightbooking.svg";
import footerbg from "./assets/footer-bg.png";
import userAvatar from "./assets/user.webp";
import i from "./assets/info.png";
import rupeeLogo from "./assets/rupee.png";
import rupee_1 from "./assets/rupee1.png";
import upiImg from "./assets/upi.svg";
import finger_printsvg from "./assets/svg/fingerprint_new.svg";
import transaction_black from "./assets/transaction18.png";
import transaction_white from "./assets/transaction_white.png";
import successGif from "./assets/success.json";
import successGif2 from "./assets/successDone.json";
import chatBox from "./assets/chat.png";
import panda_illustration from "./assets/Panda.svg";
import paytm from "./assets/paytm.svg";
import smalllogodilli from "./assets/dilliPay.ico";

// import about_us from "./assets/aboutus.webp";
import about_us from "./assets/about_us.png";
import dmt from "./assets/dmttransfer.webp";
import Office from "./assets/office.webp";
import empty_table from "./assets/Panda.svg";
import not_found_404 from "./assets/404_not_found.jpg";
import unauthorizedNew from "./assets/401_Error_Unauthorized.png";
import no_data_gif from "./assets/no_data.gif";
import noDataIllustrator1 from "./assets/noDataIllustrator1.jpg";
import noDataIllustrator2 from "./assets/noDataIllustrator2.jpg";
import fetchbill from "./assets/invoice.png";
import invoice from "./assets/sidenav/white/invoice.svg";
import wave_bg from "./assets/wave-haikei.png";
import team from "./assets/teamwork.jpg";
import redback from "./assets/redimage.jpg";
import tickmark from "./assets/tick.png";
import recharge3 from "./assets/Recharge3.png";
import insurance from "./assets/insurance .png";
import aadhar from "./assets/aadhar.png";

//bbps icons import
import broadband_svg from "./assets/svg/broadband.svg";
import broadband_invert_svg from "./assets/svg-invert/broadband.svg";
import card from "./assets/svg/credit_card.svg";
import card_invert from "./assets/svg-invert/credit_card.svg";
import car_svg from "./assets/svg/car.svg";
import car_invert_svg from "./assets/svg-invert/car_white.svg";
import clubs_svg from "./assets/svg/clubs.svg";
import clubs_svg_invert from "./assets/svg-invert/clubs.svg";
import dth_svg from "./assets/svg/dth.svg";
import dth_invert_svg from "./assets/svg-invert/dth.svg";
import electricity_invert_svg from "./assets/svg-invert/electricity.svg";
import fasttag_svg from "./assets/svg/toll_tax.svg";
import fasttag_invert from "./assets/svg-invert/toll.svg";
import gas_svg from "./assets/svg/gas.svg";
import gas_invert_svg from "./assets/svg-invert/gas.svg";
import health_svg from "./assets/svg/health.svg";
import health_invert_svg from "./assets/svg-invert/health_white.svg";
import hospital_svg from "./assets/svg/hospital.svg";
import hospital_svg_invert from "./assets/svg-invert/hospital.svg";
import housing_society_svg from "./assets/svg/housing_society.svg";
import housing_society_svg_invert from "./assets/svg-invert/housing_society.svg";
import piggy_bank_svg from "./assets/svg/piggy_bank.svg";
import recurring_deposit_svg_invert from "./assets/svg-invert/recurring_deposits.svg";
import recharge_white_svg from "./assets/svg/recharge_white.svg";
import recharge_white_invert_svg from "./assets/svg-invert/recharge_white.svg";
import subscriptions_svg from "./assets/svg/subscriptions.svg";
import subscriptions_svg_invert from "./assets/svg-invert/subscriptions.svg";
import taxes_svg from "./assets/svg/taxes.svg";
import taxes_svg_invert from "./assets/svg-invert/taxes.svg";
import water_drop_svg from "./assets/svg/water_drop.svg";
import water_drop_invert_svg from "./assets/svg-invert/water_drop.svg";
import mobile_recharge from "./assets/mobileRec.png";
import m_recharge from "./assets/recharge.png";
import bill1 from "./assets/billpayment.png";
import qr_img from "./assets/qrCode.png";
import dthrech1 from "./assets/dth.png";
import irctc from "./assets/irctc.png";
import Irctc from "./assets/icons.png";
import aadharAtm from "./assets/atm.webp";
import money_t from "./assets/moneyT.png";
import join_us from "./assets/joinus.webp";
import join_us_img from "./assets/joinus2.webp";
import contact_img from "./assets/contactus.webp";
import contactimg from "./assets/contactus.jpg";
import certificateT from "./assets/certificatetop.png";
import certificateB from "./assets/certificatebottom.png";
import playstoreIcon from "../src/assets/playstore.png";
import appStoreIcon from "../src/assets/appstore.png";
import we_are from "./assets/whowe.jpg";
import yellowinfo from "./assets/exclamation.png";
import redinfo from "./assets/siren.png";
import blueinfo from "./assets/info.svg";
import api_img from "./assets/api.webp";
import excelImage from "./assets/excel.png";
import cable from "./assets/svg/Cabletv-svg-trans.svg";
import cableInverted from "./assets/svg-invert/Cabletv_white-svg-trans.svg";
import rupay from "./assets/rupay.png";
import master from "./assets/mastercard.png";
import visa from "./assets/visa.png";
import mo_vison from "./assets/illus14.png";
import mo_mission from "./assets/illus12.png";
import mo_values from "./assets/illus151.png";
import location from "./assets/svg/location.png";
import iphone from "./assets/svg/iphone.png";
import message from "./assets/svg/message.png";
import globe from "./assets/svg/globe.png";
import stamp from "./assets/impsguru_stamp.png";
import director from "./assets/director.png";
import certificate from "./assets/svg/certificate_icon.png";
import prabhu from "./assets/prabhuMT.jpg";
import kycverification from "./assets/kyc_verification.webp";
import indNepal from "./assets/indo_nepal.webp";

import aepsAuth from "./assets/aepsAuth.webp";
import processing from "./assets/processing.png";
import creditReqImg from "./assets/just_icons/creditReq.svg";
import complaintsImg from "./assets/just_icons/complaints.svg";
import BusImage from "./assets/busimage.jpg";
import TrainImage from "./assets/irctcimage.png";
import HotelImage from "./assets/hotelimage.jpg";
import credit_1 from "./assets/dashboard_icons/credit-card.png";
import computer_1 from "./assets/dashboard_icons/laptop.webp";
import cctv_1 from "./assets/dashboard_icons/cctv.jpg";
import matm_1 from "./assets/dashboard_icons/matm.webp";
import gold_1 from "./assets/dashboard_icons/business.png";
import delivery_1 from "./assets/dashboard_icons/delivery-service.png";
import stamp_1 from "./assets/dashboard_icons/validation.png";
import motilal_1 from "./assets/dashboard_icons/motilal.webp";
import mobilephone_1 from "./assets/dashboard_icons/technology.png";
import insurance_5 from "./assets/dashboard_icons/life-insurance.png";
import Iso from "./assets/dashboard_icons/Iso.png";
import Iso2 from "./assets/dashboard_icons/iso9001.png";
import antivirus from "./assets/dashboard_icons/anitvirus.png";
import vapt from "./assets/dashboard_icons/vapt.png";
import duns from "./assets/dashboard_icons/duns.png";
import Ssl from "./assets/dashboard_icons/ssl.jpeg";
import mutual from "./assets/dashboard_icons/profits.png";
import loan_1 from "./assets/dashboard_icons/contract.png";
import account_1 from "./assets/dashboard_icons/user.png";
import demand_1 from "./assets/dashboard_icons/sticky-notes.png";
// side nav images

import linkdinIcon from "../src/assets/linkdin.png";
import twitterIcon from "../src/assets/twitter.png";
import facebookIcon from "../src/assets/facebook.png";
import youtubeIcon from "../src/assets/video.png";
import telegramIcon from "../src/assets/telegram.png";
import whatsappIcon from "../src/assets/whatsapp.png";
import threadsIcon from "../src/assets/threads.png";
import instaIcon from "../src/assets/insta.png";
import aboutUsNew from "../src/assets/aboutUs.png";
import Admindash from "./assets/AdminDash.png";
import backButton from "./assets/back.png";
import portButton from "./assets/exchange.png";
import pay from "./assets/svg/pay.svg";
import flightlogo from "./assets/svg/flight.jpeg";
import neftlogo from "./assets/svg/neft_icon.svg";
import impslogo from "./assets/svg/imps_icon.svg";
import ChildPhoto from "./assets/Child.jpg";
import Admindashlogo from "./assets/dilliPay.png";
import Upi from "./assets/svg/upi-icon.svg";
import Limiticon from "./assets/LimitAcc.png";
import Limit from "./assets/LimitTran.png";
import Nameicon from "./assets/Name.png";
import Callicon from "./assets/Call1.png";
import serviceDN from "../src/assets/serviceDown.jpg";
import unauth from "../src/assets/unauthorized.jpg";
import slide_one from "../src/assets/slide1.webp";
import slide_two from "../src/assets/slide2.webp";
import male_avatar from "../src/assets/maleAvatar.jpeg";
import female_avatar from "../src/assets/femaleAvatar.jpeg";
import phone_login from "./assets/mobile.png";
import lock_icon from "./assets/lock.png";
// new nav
import ledgre from "../src/assets/sidebar_icons/accountledger.svg";
import purchase from "../src/assets/sidebar_icons/mypurchase.svg";
import khata from "../src/assets/sidebar_icons/khatabook.svg";
import complaints from "../src/assets/sidebar_icons/mycomplaints.svg";
import credit from "../src/assets/sidebar_icons/creditrequest.svg";
import tran from "../src/assets/sidebar_icons/mytransactions.svg";
import mRec from "../src/assets/sidebar_icons/mobile.svg";
import dthI from "../src/assets/sidebar_icons/DTH.svg";
import elec from "../src/assets/sidebar_icons/electricity.svg";
import ccard from "../src/assets/sidebar_icons/creditcard.svg";
import gasI from "../src/assets/sidebar_icons/gas.svg";
import bb from "../src/assets/sidebar_icons/broad band.svg";
import aeps from "../src/assets/sidebar_icons/aeps.svg";
import mtrans from "../src/assets/sidebar_icons/money transfer.svg";
import etrans from "../src/assets/sidebar_icons/express transfer.svg";
import strans from "../src/assets/sidebar_icons/super transfer.svg";
import ntrans from "../src/assets/sidebar_icons/nepal transfer.svg";
import utrans from "../src/assets/sidebar_icons/UPI transfer.svg";
import CMS from "../src/assets/sidebar_icons/CMS.svg";
import ftag from "../src/assets/sidebar_icons/fast tag.svg";
import gcyliner from "../src/assets/sidebar_icons/gas cylinder.svg";
import mpost from "../src/assets/sidebar_icons/mobile postpaid.svg";
import mpre from "../src/assets/sidebar_icons/mobile prepaid.svg";
import gpipe from "../src/assets/sidebar_icons/piped gas.svg";
// import allbbps from "../src/assets/sidebar_icons/allbbps.svg"; ///
import allbbps from "./assets/dashboard_icons/bbps.png";

import lic from "../src/assets/sidebar_icons/LIC.svg"; ///
import land from "../src/assets/sidebar_icons/landline.svg"; ///
import water from "../src/assets/sidebar_icons/water.svg"; ///
import electricity from "./assets/svg/electricity.svg";
import drawer from "../src/assets/sidebar_icons/drawer.png";
import defaultL from "../src/assets/defaultLayout.png";
import sbi from "../src/assets/just_icons/bank_img.png";
import cms from "./assets/just_icons/cms2.png";
import aepsGuidelines from "./assets/aeps-guidelines.png";
import aepsGuidelinesNew from "./assets/aeps-guidelines-new.png";
import creditReqGuidelines from "./assets/credit-request-disclaimer.png";
import irctcAuth from "./assets/irctc-auth.png";
import irctcTravel from "./assets_travel/images/irctc.jpg";
//dashboard
import money_l from "./assets/dashboard_icons/money.png";
import cms_1 from "./assets/dashboard_icons/cms.png";
import nepal_1 from "./assets/dashboard_icons/nepal.png";
import vpay_1 from "./assets/dashboard_icons/vpay.png";
import upi_1 from "./assets/dashboard_icons/upi.png";
import aeps_1 from "./assets/dashboard_icons/aeps.png";
import cylinder_1 from "./assets/dashboard_icons/gas-cylinder.png";
import bus_1 from "./assets/dashboard_icons/bus.png";
import train_1 from "./assets/dashboard_icons/train.png";
import hotel_1 from "./assets/dashboard_icons/hotel.png";
import airplane_1 from "./assets/dashboard_icons/airplane.png";
import dth_1 from "./assets/dashboard_icons/dth.png";
import recharge_1 from "./assets/dashboard_icons/recharge.png";
import postpaid_1 from "./assets/dashboard_icons/postpaid.png";
import bbps_1 from "./assets/dashboard_icons/bbps.png";

import electricity_1 from "./assets/dashboard_icons/electricity.png";
import insurance_1 from "./assets/dashboard_icons/insurance.png";
import creditcard_1 from "./assets/dashboard_icons/creditcard.png";
import gas_1 from "./assets/dashboard_icons/gas.png";
import water_1 from "./assets/dashboard_icons/water.png";
import landline_1 from "./assets/dashboard_icons/landline.png";
import broadband_1 from "./assets/dashboard_icons/broadband.png";
import impsLogo from "./assets/IMPSLogo.png";
import neftLogo from "./assets/NeftLogo.png";
import android_1 from "./assets/android1.png";
import macintosh_1 from "./assets/macintosh.png";
import windows_1 from "./assets/windows1.png";
import linux_1 from "./assets/linux.png";
import signAvatar from "./assets/signAvatar.png";
import pnb from "./assets/bankicons/pnb.png";
import sbib from "./assets/bankicons/sbi.png";
import axis from "./assets/bankicons/Axis.jpg";
// import idfc from "./assets/bankicons/idfc.jpg"
import yesbank from "./assets/bankicons/yes.png";
import hdfc from "./assets/bankicons/hdfc.png";
import rbl from "./assets/bankicons/rbl.png";
import idfc from "./assets/bankicons/IDFC.png";
import defaultbank from "./assets/bankicons/defaultBank.svg";
import ujjivanB from "./assets/bankicons/ujjivan.jpeg";
import auBank2 from "./assets/bankicons/aubank.jpg";
import indus1 from "./assets/bankicons/indus.jpg";
import suryoday1 from "./assets/bankicons/suryoday.png";

import pnbs from "./assets/bankicons/pnb.svg";
import sbibs from "./assets/bankicons/sbi.svg";
import axiss from "./assets/bankicons/Axis.jpg";
// import idfc from "./assets/bankicons/idfc.jpg"
import yesbanks from "./assets/bankicons/yes.svg";
import hdfcs from "./assets/bankicons/hdfc.svg";
import rbls from "./assets/bankicons/rbl.svg";
import idfcs from "./assets/bankicons/IDFC.svg";
import igl from "./assets/IGL.png";

import ppe from "./assets/svg/ppe.png";

export const iglI = igl;
export const ppeI = ppe;
export const sbiB = sbib;
export const pnbB = pnb;
export const axisB = axis;
export const rblB = rbl;
export const yesbankB = yesbank;
export const hdfcB = hdfc;
export const idfcB = idfc;
export const defaultBIcon = defaultbank;
export const ujjivanb = ujjivanB;
export const aubank = auBank2;
export const indus = indus1;
export const suryoday = suryoday1;

export const sbiS = sbibs;
export const pnbS = pnbs;
export const axisS = axiss;
export const rblS = rbls;
export const yesbankS = yesbanks;
export const hdfcS = hdfcs;
export const idfcS = idfcs;

export const Logo = biggpayLogo;
export const smLogo = biggpayLogo_sm;
export const TrainsImage = TrainImage;
export const HotelsImage = HotelImage;
export const BusesImage = BusImage;
export const LoginPageIllustratorImg = LoginPageIllustrator;

export const imps_l = impsLogo;
export const neft_l = neftLogo;

//bbps export
export const bbpsPng = bbps;
// bbps icons . . .
export const electricity_svg = electricity;
export const electricity_invert = electricity_invert_svg;
export const broadband = broadband_svg;
export const broadband_invert = broadband_invert_svg;
export const car = car_svg;
export const carInvert = car_invert_svg;
export const clulbSvg = clubs_svg;
export const clulbSvgInvert = clubs_svg_invert;
export const dth = dth_svg;
export const dth_invert = dth_invert_svg;
export const fastTag = fasttag_svg;
export const fastTag_invert = fasttag_invert;
export const gas = gas_svg;
export const gas_invert = gas_invert_svg;
export const health = health_svg;
export const healthInvert = health_invert_svg;
export const hospitalSvg = hospital_svg;
export const hospitalSvgInvert = hospital_svg_invert;
export const housingSvg = housing_society_svg;
export const housingSvgInvert = housing_society_svg_invert;
export const piggyBankSvg = piggy_bank_svg;
export const rDepositSvgInvert = recurring_deposit_svg_invert;
export const recharge_white = recharge_white_svg;
export const recharge_white_invert = recharge_white_invert_svg;
export const subsciptionSvg = subscriptions_svg;
export const subsciptionSvgInvert = subscriptions_svg_invert;
export const taxSvg = taxes_svg;
export const taxSvgInvert = taxes_svg_invert;
export const water_drop = water_drop_svg;
export const water_drop_invert = water_drop_invert_svg;
export const credit_card = card;
export const credit_card_invert = card_invert;
//my imports
export const irctcAuthImg = irctcAuth;
export const paytm_img = paytm;
export const success_gif = successGif;
export const success_gif2 = successGif2;
export const transactionBlack = transaction_black;
export const transactionWhite = transaction_white;
export const upiWeb = upiImg;
export const rupee = rupeeLogo;
export const rupee1 = rupee_1;
export const info = i;
export const userAvt = userAvatar;
export const footerBg = footerbg;
export const contactus = contact;
export const dashboard = dash;
export const expressTransfer = express;
export const moneyTransfer = money;
export const recharge = rechargeicon;
export const transaction = txn;
export const upi = upiTrans;
export const hotelBooking = hotel;
export const flightBooking = flight;
export const busBooking = bus;

export const lp_illustration = landingPageIllustration;
export const lp_illustration2 = landingPageIllustration1;
export const lg_illustration = login_illustration;
export const panda = panda_illustration;
export const aboutUs = about_us;
export const DMT = dmt;
export const office = Office;
export const mobile = mobile_recharge;
export const mobileR_img = m_recharge;
export const bill = bill1;
export const irctc_img = irctc;
export const Irctc_img = Irctc;
export const qrCode_img = qr_img;
export const dthrech = dthrech1;
export const aadharAtm_img = aadharAtm;
export const mt = money_t;
export const emptyTable = empty_table;
export const notFound404 = not_found_404;
export const unauthorized401 = unauthorizedNew;
export const noDataFoundGif = no_data_gif;
// export const noDataIllustrator = noDataIllustrator1;
export const noDataIllustrator = noDataIllustrator2;
export const Bill = fetchbill;
export const invoice1 = invoice;
export const waveBg = wave_bg;
export const joinus = join_us;

export const joinus2 = join_us_img;
export const contact_us = contact_img;
export const contact_Us = contactimg;
export const who_we_are = we_are;
export const teamWork = team;
export const Redback = redback;
export const tick = tickmark;
export const Recharge3 = recharge3;
export const insurance3 = insurance;
export const aadhar3 = aadhar;

export const yellowNoti = yellowinfo;
export const redNoti = redinfo;
export const blueNoti = blueinfo;
export const api = api_img;
export const excelIcon = excelImage;
export const CableIcon = cable;
export const CableInv = cableInverted;
export const playstore = playstoreIcon;
export const appstore = appStoreIcon;
export const linkdin = linkdinIcon;
export const twitter = twitterIcon;
export const facebook = facebookIcon;
export const youtube = youtubeIcon;
export const telegram = telegramIcon;
export const whatsapp = whatsappIcon;
export const threads = threadsIcon;
export const insta = instaIcon;
export const rupayimg = rupay;
export const visaimg = visa;
export const masterimg = master;
export const ModrAboutus = aboutUsNew;
export const loginPage = Admindash;
export const back = backButton;
export const port = portButton;
export const paylogo = pay;
export const flight1 = flightlogo;
export const Neftlogo = neftlogo;
export const Impslogo = impslogo;
export const Banner = ChildPhoto;
export const loginPage1 = Admindashlogo;
export const UpiLogo = Upi;
export const Name = Nameicon;
export const LimitAcc = Limiticon;
export const LimitTran = Limit;
export const Call1 = Callicon;
export const serviceDown = serviceDN;
export const unauthorized = unauth;

export const chat = chatBox;

export const moVision = mo_vison;
export const smalllogo1 = smalllogodilli;

export const moMisson = mo_mission;
export const moValues = mo_values;

export const locIcon = location;
export const messIcon = message;
export const iphoneIcon = iphone;
export const globeIcon = globe;
export const impsguruStamp = stamp;
export const dilliPaysign = director;
export const certificateIcon = certificate;
export const prabhuMoneyTransfer = prabhu;
export const kycVImg = kycverification;
export const indoNepal = indNepal;

export const slider1 = slide_one;
export const slider2 = slide_two;

export const account_ledgre = ledgre;
export const transactions = tran;
export const creditReq = credit;
export const creditReqBadgeIcon = creditReqImg;
export const complaintsBadgeIcon = complaintsImg;
export const khataBook = khata;
export const myComplaints = complaints;
export const myPurchase = purchase;
export const topDrawer = drawer;
export const defaultLayout = defaultL;
export const sbiBank = sbi;

export const cTop = certificateT;
export const cBottom = certificateB;
export const aepsAuthImg = aepsAuth;
export const processingImg = processing;

export const mrecIcon = mRec;
export const dthIcon = dthI;
export const elecIcon = elec;
export const cardIcon = ccard;
export const gasIcon = gasI;
export const bbIcon = bb;
export const aepsIcon = aeps;
export const mtIcon = mtrans;
export const etIcon = etrans;
export const stIcon = strans;
export const ntIcon = ntrans;
export const utIcon = utrans;
export const CMSIcon = CMS;
export const Electricity = elec;
export const FASTag = ftag;
export const Cylinder = gcyliner;
export const Postpaid = mpost;
export const Prepaid = mpre;
export const Gas = gpipe;
export const BBPS = allbbps;
export const licIcon = lic;
export const landIcon = land;
export const waterIcon = water;
export const AirIndia = airIndia;
export const closeIcon = closeicon;
export const success_vdo = successVdo;
export const failed_vdo = failedVdo;
export const fingerSvg = finger_printsvg;
export const cmsIcon = cms;
export const aepsGuidelinesImg = aepsGuidelines;
export const aepsGuidelinesNewImg = aepsGuidelinesNew;
export const creditReqGuidelinesImg = creditReqGuidelines;
export const irctcTravelImage = irctcTravel;
export const small_logo = smallLogo;
export const outletRegImg = outlet_reg_img;
export const maleAvatar = male_avatar;
export const femaleAvatar = female_avatar;
export const mobilelogin = phone_login;
export const lockicon = lock_icon;

export const moneyl = money_l;
export const nepal1 = nepal_1;
export const cms1 = cms_1;
export const newCredit = credit_1;
export const computer = computer_1;
export const cctv = cctv_1;
export const matm = matm_1;
export const gold = gold_1;
export const delivery = delivery_1;
export const stamppaper = stamp_1;
export const motilal = motilal_1;
export const mobilephone = mobilephone_1;
export const newinsurance = insurance_5;
export const iso1 = Iso;
export const iso2 = Iso2;
export const ssl1 = Ssl;
export const antivirus1 = antivirus;
export const vapt1 = vapt;
export const duns1 = duns;
export const mutualfunds = mutual;
export const Loan = loan_1;
export const account = account_1;
export const demand = demand_1;
export const vpay1 = vpay_1;
export const aeps1 = aeps_1;
export const cylinder = cylinder_1;
export const upi1 = upi_1;
export const bus1 = bus_1;
export const train1 = train_1;
export const airplane1 = airplane_1;
export const hotel1 = hotel_1;
export const electricity1 = electricity_1;
export const insurance1 = insurance_1;
export const creditcard1 = creditcard_1;
export const dth1 = dth_1;
export const landline1 = landline_1;
export const broadband1 = broadband_1;
export const gas1 = gas_1;
export const water1 = water_1;
export const recharge1 = recharge_1;
export const postpaid1 = postpaid_1;
export const bbps1 = bbps_1;
export const android2 = android_1;
export const macintosh2 = macintosh_1;
export const windows2 = windows_1;
export const linux2 = linux_1;
export const signAvatars = signAvatar;
export const ItrIage = ITR;
